<template>
  <el-row :gutter="10">
    <el-form @submit.native.prevent>
      <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
        <el-form-item
          ref="phonecode"
          :error="
            retrieveFieldError(
              this.$props.ModelState,
              this.$props.PhoneCodeField
            )
          "
          :required="true"
        >
          <el-autocomplete
            class="inline-input mb10"
            v-model="selectedCountry"
            :fetch-suggestions="querySearch"
            placeholder="Type country"
            :trigger-on-focus="false"
            @select="handleCountrySelect"
            :clearable="true"
            @clear="clearCountryCode"
          >
            <template slot-scope="{ item }">
              <el-tooltip placement="left">
                <div slot="content">
                  <span>{{ item.value }}</span>
                </div>
                <span>{{ item.value }}</span>
              </el-tooltip>
            </template>
          </el-autocomplete>
        </el-form-item>
      </el-col>
      <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
        <el-form-item
          ref="phonenumber"
          :error="
            retrieveFieldError(
              this.$props.ModelState,
              this.$props.PhoneNumberField
            )
          "
          :required="true"
        >
          <el-input
            class="mb10"
            placeholder=""
            type="number"
            min="0"
            oninput="validity.valid||(value='');"
            v-model="phoneNumber"
          >
          </el-input>
        </el-form-item>
      </el-col>
    </el-form>
  </el-row>
</template>
<script>
export default {
  name: "PhoneNumber",
  props: {
    ModelState: {
      type: Object,
      default: {}
    },
    PhoneCodeField: {
      type: String,
      default: "CompanyDetails.CountryInternationalCode"
    },
    PhoneNumberField: {
      type: String,
      default: "CompanyDetails.TelephoneNumber"
    },
    PhoneNumber: {
      type: String,
      default: ""
    },
    CountryCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      countries: [],
      selectedPhoneCode: "+1",
      selectedCountry: "United States | +1",
      phoneNumber: "",
      value: "",
      selectedCountryCode: "US"
    };
  },
  created() {
    this.$store.dispatch("common/getCountries").then(res => {
      this.countries = res;

      if (this.$props.PhoneNumber != "") {
        let country = {};
        if (this.$props.CountryCode == "") {
          country =
            this.$props.PhoneNumber.indexOf(" ") != -1
              ? this.countries.find(c =>
                  c.phoneCode.indexOf("+") === 0
                    ? c.phoneCode === this.$props.PhoneNumber.split(" ")[0]
                    : c.phoneCode ===
                      this.$props.PhoneNumber.split(" ")[0].slice(1)
                )
              : null;
        } else {
          country = this.countries.find(c => c.code == this.$props.CountryCode);
        }

        this.selectedCountry =
          country != null
            ? country.name +
              " | " +
              (country.phoneCode.indexOf("+") === 0
                ? country.phoneCode
                : "+" + country.phoneCode)
            : this.selectedCountry;
      }
    });
  },
  watch: {
    phoneNumber: function(newValue, oldValue) {
      if (newValue != "") {
        this.clearValidation("phonenumber");
      }
      this.$emit("phone-input", newValue);
    },
    selectedPhoneCode: function(newValue, oldValue) {
      if (newValue != "") {
        this.clearValidation("phonecode");
      }
      this.$emit("intl-code-selected", newValue);
    },
    PhoneNumber: function(newValue, oldValue) {
      if (newValue != "") {
        this.phoneNumber =
          newValue.indexOf(" ") != -1 ? newValue.split(" ")[1] : newValue;
      }
    }
  },
  methods: {
    querySearch(queryString, cb) {
      var results = queryString
        ? this.countries
            .filter(
              c => c.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
            )
            .map(a => ({
              value:
                a.name +
                " | " +
                (a.phoneCode.indexOf("+") === 0
                  ? a.phoneCode
                  : "+" + a.phoneCode),
              data: a
            }))
        : this.countries;
      if (results.length === 0) {
        this.selectedPhoneCode = queryString;
      }
      cb(results);
    },
    handleCountrySelect(item) {
      this.selectedPhoneCode =
        item.data.phoneCode.indexOf("+") === 0
          ? item.data.phoneCode
          : "+" + item.data.phoneCode;
      this.$emit("phone-country-code-selected", item.data.code);
    },
    clearCountryCode() {
      this.selectedPhoneCode = "";
      this.$emit("phone-country-code-selected", "");
    },
    clearValidation(field) {
      this.$refs[field].clearValidate();
    },
    reset() {
      this.selectedCountry = "United States | +1";
      this.phoneNumber = "";
    }
  }
};
</script>
